<template>
  <v-row>
    <v-col style="overflow-y: scroll; height: calc(100vh - 160px);">
      <div
        class="modal-processor-detail"
        :style="{ 'margin': '0 auto', 'max-width': isTestingScript ? '100%' : '845px' }"
      >
        <BaseBreadcrumb :config="breadcrumbList" />
        <div class="app-align-items-center">
          <template v-if="rulesLogs && rulesLogs.length">
            <BaseButton
              :has-icon="true"
              color="primary"
              class="mx-0 my-3 pa-4"
              size="x-small"
              :is-disabled="rulesLogs && rulesLogs.length - 1 == indexCurrentRule || (isTestingScript || isEditingParam != null)"
              @click="selectLog(indexCurrentRule + 1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </BaseButton>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="mx-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    small
                    class="mb-1"
                  >
                    mdi-history
                  </v-icon>
                  {{ currentTimestamp ? `${currentTimestamp} | Alterado por: ${currentInitiatedBy}` : 'Histórico de versão' }}
                </div>
              </template>
              <span v-if="indexCurrentRule === 0 && rulesLogs.length">
                Última versão: {{ rulesLogs[0].timestamp | getDate }} - {{ rulesLogs[0].timestamp | getFullTime }} |
                Alterado por: {{ formatInitiatedBy(rulesLogs[0].initiated_by) }}
              </span>
              <span v-else>Comparando a última versão com a selecionada</span>
            </v-tooltip>
            <BaseButton
              :has-icon="true"
              color="primary"
              class="mx-0 my-3 pa-4 mr-2"
              size="x-small"
              :is-disabled="indexCurrentRule == 0 || (isTestingScript || isEditingParam != null)"
              @click="selectLog(indexCurrentRule - 1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </BaseButton>
          </template>
          <v-alert
            v-if="processorAreEdited"
            dense
            outlined
            class="warning--text my-2 py-1 px-2 body-2"
          >
            <v-icon
              small
              color="orange"
              class="pr-1"
              style="padding-bottom: 2px;"
            >
              mdi-alert-circle
            </v-icon> Alterações não salvas no processador
          </v-alert>

          <v-spacer />

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
              >
                <BaseButton
                  v-if="!isTestingScript"
                  :has-icon="false"
                  type="fab"
                  color="primary"
                  size="x-small"

                  @click="testingProcessor()"
                >
                  <v-icon>mdi-lightning-bolt</v-icon>
                </BaseButton>
              </span>
            </template>
            <span>{{ testProcessor ? 'Fechar aba de testes' : 'Configure e execute o teste do processador' }}</span>
          </v-tooltip>
        </div>
        <BaseCard
          :has-main-container="true"
        >
          <v-tabs
            v-model="tabIndex"
            align-with-title
            class="tabs tab-details"
          >
            <v-tabs-slider />
            <v-tab
              v-for="tab, index in ['Detalhes', 'Parâmetros']"
              :key="index"
              :disabled="isTestingScript || isEditingParam != null"
              class="tab"
            >
              <span class="tab--text">{{ tab }}</span>
            </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="tabIndex"
            :style="{ 'background': isDarkTheme ? '#2d2d2d' : '#f8f8f8'}"
          >
            <v-form v-model="formIsValid">
              <v-tab-item :transition="false">
                <div class="app-align-items-center ma-2">
                  <v-spacer />
                  <BaseButton
                    type="text"
                    color="blueff"
                    class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                    :is-disabled="!isEditingProcessor"
                    @click="isEditingProcessor = false"
                  >
                    Desabilitar
                  </BaseButton>
                  <BaseButton
                    type="text"
                    color="blueff"
                    class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                    :is-disabled="isEditingProcessor"
                    @click="isEditingProcessor = true"
                  >
                    Editar
                  </BaseButton>
                </div>
                <template v-if="isEditingProcessor">
                  <v-container class="px-4 py-6">
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('alias')}"
                      >
                        <BaseInput
                          v-model="processorObject.alias"
                          qa-identification-name="qa-id-name-processor-code"
                          persistent-hint
                          hint="Digite um alias para facilitar a identificação"
                          label="Alias"
                          :prepend-icon="highlightField('alias') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('eventType')}"
                      >
                        <v-autocomplete
                          v-model="processorObject.eventType"
                          :items="eventTypesList"
                          :rules="[isValid]"
                          item-text="type"
                          item-value="uuid"
                          label="Event Type *"
                          :prepend-icon="highlightField('eventType') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('processorContext')}"
                      >
                        <BaseInput
                          v-model="processorObject.processorContext"
                          :rules="[isValid]"
                          qa-identification-name="qa-id-name-processor-name"
                          label="Context *"
                          :prepend-icon="highlightField('processorContext') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('processorMatchers')}"
                      >
                        <BaseInput
                          v-model="processorObject.processorMatchers"
                          qa-identification-name="qa-id-name-processor-code"
                          label="Matchers"
                          :prepend-icon="highlightField('processorMatchers') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('processorParentName')}"
                      >
                        <BaseInput
                          v-model="processorObject.processorParentName"
                          qa-identification-name="qa-id-name-processor-code"
                          label="Parent Processor"
                          :prepend-icon="highlightField('processorParentName') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('executionStep')}"
                      >
                        <BaseInput
                          v-model="processorObject.executionStep"
                          qa-identification-name="qa-id-name-processor-code"
                          persistent-hint
                          hint="Nome da etapa da execução (Use 'platform:{Nome-da-etapa}' para definir que este processor faz parte da etapa nomeada da excecução. Use '-' para a etapa ser ignorada)"
                          label="Execution Step"
                          :prepend-icon="highlightField('executionStep') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                    <v-row
                      dense
                      class="my-1"
                    >
                      <v-col
                        cols="auto"
                        sm="12"
                        class="px-0"
                        :class="{'custom-highlight-field': highlightField('processorPriority')}"
                      >
                        <BaseInput
                          v-model="processorObject.processorPriority"
                          qa-identification-name="qa-id-name-processor-priority"
                          label="Prioridade"
                          :prepend-icon="highlightField('processorPriority') ? 'mdi-history' : null"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <p class="app-align-items-center mx-4 mt-6 mb-4">
                  Initiator
                  <v-spacer />
                  <span class="text-right">
                    {{ processorInitiator || 'DEFAULT' }}
                  </span>
                </p>
                <BaseDataTable
                  v-if="!isEditingProcessor"
                  :items="Object.keys(processorObject)"
                  :hide-headers="true"
                  :hide-actions="true"
                  background-color="transparent"
                  :options="{ page: 1, itemsPerPage: Object.keys(processorObject).length + 1 }"
                  class="create-asset-data-table mb-6"
                >
                  <template v-slot:inject-items="scopedItems">
                    <tr
                      v-for="items in scopedItems"
                      :key="items.index"
                      :class="{'custom-highlight-field': highlightField(items.item)}"
                    >
                      <template v-if="items.item == 'processorConfUuid'">
                        <td class="text-capitalize">
                          {{ parseName(items.item) }}
                        </td>
                        <td class="text-right">
                          {{ processorObject[items.item] || '-' }}
                          <BaseButton
                            :has-icon="true"
                            class="ma-0 ml-2 pa-4"
                            size="x-small"
                            @click="copyId(processorObject[items.item])"
                          >
                            <v-icon>{{ isIdCopied ? 'mdi-check-all' : 'mdi-content-copy' }}</v-icon>
                          </BaseButton>
                        </td>
                      </template>
                      <template v-else-if="hideItems(items.item)">
                        <td class="text-capitalize">
                          <v-icon
                            v-if="highlightField(items.item)"
                            small
                          >
                            mdi-history
                          </v-icon>
                          {{ parseName(items.item) }}
                        </td>
                        <td class="text-right">
                          {{ processorObject[items.item] || '-' }}
                        </td>
                      </template>
                    </tr>
                  </template>
                </BaseDataTable>
                <div
                  class="pa-4 ma-0"
                  :class="{'custom-highlight-field': highlightField('comment')}"
                >
                  <p class="body-2 mb-2">
                    <v-icon
                      v-if="highlightField('comment')"
                      small
                    >
                      mdi-history
                    </v-icon>
                    Comentários
                  </p>
                  <BaseCodemirror
                    ref="cmComment"
                    v-model="processorObject.comment"
                    cm-ref="cmComment"
                    :cm-height="400"
                    :read-only="!isEditingProcessor"
                  />
                </div>
              </v-tab-item>
              <v-tab-item
                :transition="false"
              >
                <template v-if="!isTestingScript">
                  <v-row
                    dense
                    class="mt-6 mx-1"
                  >
                    <v-col cols="auto">
                      <BaseButton
                        type="depressed"
                        color="primary"
                        :is-disabled="isTestingScript || isEditingParam != null"
                        @click="addParam"
                      >
                        Adicionar
                      </BaseButton>
                      <BaseButton
                        color="primary"
                        type="text"
                        :is-disabled="processorSearchLoad || (isTestingScript || isEditingParam != null)"
                        @click="searchProcessorDefinition(processorObject)"
                      >
                        Buscar
                        <v-progress-circular
                          v-if="processorSearchLoad"
                          indeterminate
                          size="16"
                          width="2"
                          color="primary"
                          class="ml-2"
                        />
                      </BaseButton>
                    </v-col>
                  </v-row>
                  <p
                    v-if="!processorObject.processorParams || !processorObject.processorParams.length"
                    class="mx-4 my-10"
                  >
                    Nenhum parâmetro cadastrado.
                  </p>
                  <v-card
                    v-for="param, index in processorObject.processorParams"
                    :key="index"
                    outlined
                    class="ma-4 param-card"
                  >
                    <v-card-actions class="my-4 mb-2 mx-4 pa-0 app-align-items-center">
                      <p class="font-weight-bold">
                        Parâmetro {{ index + 1 }}
                      </p>
                      <v-spacer />
                      <div class="app-align-items-center">
                        <v-spacer />
                        <BaseButton
                          v-if="isEditingParam == index"
                          color="primary"
                          type="text"
                          @click="modalConfigMutant(index)"
                        >
                          Configuração
                        </BaseButton>
                        <v-tooltip
                          v-if="showUndoButton(index)"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <BaseButton
                              type="text"
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              @click="undoParamChanges(param, index)"
                            >
                              Cancelar
                            </BaseButton>
                          </template>
                          <span>Desfazer alterações</span>
                        </v-tooltip>
                        <BaseButton
                          v-else-if="param.isNew"
                          color="primary"
                          type="text"
                          @click="cancelEditParam(index)"
                        >
                          Cancelar
                        </BaseButton>
                        <v-tooltip
                          v-if="isEditingParam == index"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <BaseButton
                              type="depressed"
                              color="primary"
                              v-bind="attrs"
                              :is-disabled="!formIsValid || !param.value"
                              v-on="on"
                              @click="disableForm(index)"
                            >
                              Ok
                            </BaseButton>
                          </template>
                          <span>{{ showUndoButton(index) ? 'Ainda será necessário salvar o processor' : 'Desabilitar formulário' }}</span>
                        </v-tooltip>

                        <BaseButton
                          v-if="isEditingParam !== index"
                          :has-icon="true"
                          color="primary"
                          class="my-3 pa-4"
                          size="x-small"
                          :is-disabled="isEditingParam !== null"
                          @click="editParam(param, index)"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </BaseButton>
                        <BaseButton
                          v-if="isEditingParam !== index"
                          :has-icon="true"
                          color="primary"
                          class="mx-0 my-3 pa-4"
                          size="x-small"
                          :is-disabled="isEditingParam !== null"
                          @click="deleteParam(param, index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </BaseButton>
                      </div>
                    </v-card-actions>

                    <v-card-text class="pt-0">
                      <template v-if="isEditingParam == index">
                        <v-row dense>
                          <v-col
                            cols="auto"
                            sm="6"
                            class="px-1"
                            :class="{'custom-highlight-div-field': highlightField('param'+index) }"
                          >
                            <BaseInput
                              :ref="`key-param-param-${index}`"
                              v-model="param.param"
                              :rules="[isValid]"
                              label="Nome *"
                              :prepend-icon="highlightField('param'+index) ? 'mdi-history' : null"
                            />
                          </v-col>
                          <v-col
                            cols="auto"
                            sm="4"
                            class="px-0 ml-1"
                            :class="{'custom-highlight-div-field': highlightField('type'+index) }"
                          >
                            <v-select
                              :ref="`key-param-type-${index}`"
                              v-model="param.type"
                              :rules="[isValid]"
                              :items="['TEXT', 'STRING', 'JSON', 'SCRIPT']"
                              label="Tipo *"
                              class="mr-2"
                              :prepend-icon="highlightField('type'+index) ? 'mdi-history' : null"
                            />
                          </v-col>
                          <v-col
                            cols="auto"
                            sm="1"
                            class="px-0"
                          >
                            <template v-if="isEditingParam == index">
                              <v-tooltip
                                v-if="param.type == 'SCRIPT'"
                                bottom
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <BaseButton
                                    :has-icon="true"
                                    color="primary"
                                    class="mx-0 my-3 pa-4"
                                    size="x-small"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="testScript(index)"
                                  >
                                    <v-icon>mdi-code-block-tags</v-icon>
                                  </BaseButton>
                                </template>
                                <span>Testar script</span>
                              </v-tooltip>
                              <v-tooltip
                                v-else-if="param.type == 'JSON'"
                                bottom
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <BaseButton
                                    :has-icon="true"
                                    color="primary"
                                    class="mx-0 my-3 pa-4"
                                    size="x-small"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="validateJson(param.value)"
                                  >
                                    <v-icon>mdi-code-json</v-icon>
                                  </BaseButton>
                                </template>
                                <span>Validar JSON</span>
                              </v-tooltip>
                            </template>
                          </v-col>
                        </v-row>
                        <v-row
                          dense
                          class="my-2"
                        >
                          <v-col
                            cols="auto"
                            sm="12"
                            class="px-0"
                            :class="{'custom-highlight-div-field': highlightField('value'+index) }"
                          >
                            <p>
                              <v-icon
                                v-if="highlightField('value'+index)"
                                class="mb-1 mx-1"
                                small
                              >
                                mdi-history
                              </v-icon>
                              <b>Valor</b>
                            </p>
                            <BaseCodemirror
                              :ref="`key-param-value-${index}`"
                              v-model="param.value"
                              :cm-ref="`key-param-value-${index}`"
                              :cm-height="400"
                              class="ma-2"
                            />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else>
                        <v-row
                          dense
                          class="my-2"
                        >
                          <v-col
                            class="mr-1"
                            :class="{'custom-highlight-div-field': highlightField('param'+index) }"
                          >
                            <p>
                              <v-icon
                                v-if="highlightField('param'+index)"
                                class="mb-1 mx-1"
                                small
                              >
                                mdi-history
                              </v-icon>
                              <b>Nome</b>
                              {{ param.param }}
                            </p>
                          </v-col>
                          <v-col :class="{'custom-highlight-div-field': highlightField('type'+index) }">
                            <p>
                              <v-icon
                                v-if="highlightField('type'+index)"
                                class="mb-1 mx-1"
                                small
                              >
                                mdi-history
                              </v-icon>
                              <b>Tipo</b>
                              {{ param.type }}
                            </p>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="param.value && param.value.length <= 70"
                          dense
                          class="my-2"
                        >
                          <v-col :class="{'custom-highlight-div-field': highlightField('value'+index) }">
                            <p>
                              <v-icon
                                v-if="highlightField('value'+index)"
                                class="mb-1 mx-1"
                                small
                              >
                                mdi-history
                              </v-icon>
                              <b>Valor</b> {{ param.value }}
                            </p>
                          </v-col>
                        </v-row>
                        <v-row
                          v-else
                          dense
                          class="my-2"
                        >
                          <v-col :class="{'custom-highlight-div-field': highlightField('value'+index) }">
                            <p>
                              <v-icon
                                v-if="highlightField('value'+index)"
                                class="mb-1 mx-1"
                                small
                              >
                                mdi-history
                              </v-icon>
                              <b>Valor</b>
                            </p>
                            <v-textarea
                              v-model="param.value"
                              disabled
                              dense
                              hide-details
                              :rows="expandParamValue[index] ? 10 : 2"
                              class="param-value-processor mb-1 ml-1"
                            />
                            <p
                              style="cursor: pointer;"
                              @click="expandParam(index)"
                            >
                              <v-icon small>
                                {{ expandParamValue[index] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                              </v-icon>
                              {{ expandParamValue[index] ? 'Reduzir' : 'Expandir' }}
                            </p>
                          </v-col>
                        </v-row>
                      </template>
                    </v-card-text>
                  </v-card>
                </template>
                <div
                  v-else
                  class="ma-4"
                >
                  <BaseButton
                    color="primary"
                    type="text"
                    class="ma-0"
                    @click="closeScriptTest()"
                  >
                    <v-icon small>
                      mdi-arrow-left
                    </v-icon>
                    Voltar
                  </BaseButton>
                  <div class="app-align-items-center mb-4">
                    <p class="primary--text">
                      <span class="font-weight-bold">PARÂMETRO:</span> {{ processorObject.processorParams[testIndexScript].param }}
                    </p>
                    <v-spacer />
                    <BaseButton
                      type="depressed"
                      color="primary"
                      @click="scriptValidation()"
                    >
                      Testar Script
                    </BaseButton>
                  </div>
                  <v-divider class="my-4" />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <BaseButton
                        :has-icon="true"
                        color="primary"
                        class="mx-0 my-3 pa-4"
                        size="small"
                        v-bind="attrs"
                        v-on="on"
                        @click="showProtobufSchema = !showProtobufSchema"
                      >
                        <v-icon>{{ showProtobufSchema ? 'mdi-menu-open' : 'mdi-menu-close' }}</v-icon>
                      </BaseButton>
                    </template>
                    <span>{{ showProtobufSchema ? 'Ocultar Schemas de Protobuf' : 'Mostrar schemas de Protobuf' }}</span>
                  </v-tooltip>
                  <v-row>
                    <v-col
                      v-if="showProtobufSchema"
                      sm="3"
                      class="px-0"
                    >
                      <ProtobofSchema
                        @insert-value="handleValue"
                      />
                    </v-col>
                    <v-col :cols="showProtobufSchema ? 9 : 12">
                      <BaseCodemirror
                        ref="CodemirrorEditor"
                        v-model="processorObject.processorParams[testIndexScript].value"
                        cm-ref="CodemirrorEditor"
                        :cm-height="400"
                      />
                    </v-col>
                  </v-row>
                  <template v-if="resultTest.status && showAlert">
                    <v-divider class="my-8" />
                    <p class="primary--text font-weight-bold my-4 app-result-block">
                      RESULTADO
                    </p>
                    <v-alert
                      v-model="showAlert"
                      :color="resultStatus(resultTest).color"
                      dismissible
                      text
                    >
                      <div class="app-align-items-center">
                        <b>{{ resultStatus(resultTest).text }}</b>
                        <v-spacer />

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <BaseButton
                              v-if="resultTest.value.startsWith('{')"
                              :has-icon="true"
                              class="ma-0 ml-2 pa-4"
                              size="x-small"
                              :color="resultStatus(resultTest).color"
                              v-bind="attrs"
                              v-on="on"
                              @click="parseResult = !parseResult"
                            >
                              <v-icon>mdi-code-json</v-icon>
                            </BaseButton>
                          </template>
                          <span>Formatar JSON</span>
                        </v-tooltip>
                        <BaseButton
                          :has-icon="true"
                          class="ma-0 ml-2 pa-4"
                          size="x-small"
                          :color="resultStatus(resultTest).color"
                          @click="resultStatus(resultTest).action()"
                        >
                          <v-icon>{{ isIdCopied ? 'mdi-check-all' : 'mdi-content-copy' }}</v-icon>
                        </BaseButton>
                      </div>
                      <v-divider
                        class="my-4"
                        :class="resultStatus(resultTest).color"
                        style="opacity: 0.22"
                      />

                      <template v-if="resultTest.status === 'ERROR'">
                        <p>{{ resultTest.message }}</p>
                      </template>
                      <template v-else>
                        <pre v-if="parseResult">{{ JSON.parse(resultTest.value) }}</pre>
                        <p v-else>
                          {{ resultTest.value }}
                        </p>
                      </template>
                    </v-alert>
                  </template>
                  <v-divider class="my-8" />
                  <p class="primary--text font-weight-bold my-4">
                    BINDINGS
                  </p>
                  <v-row>
                    <v-col class="px-0">
                      <BaseInput
                        v-model="bindingName"
                        label="Parâmetro"
                      />
                    </v-col>
                    <v-col>
                      <BaseInput
                        v-model="bindingValue"
                        label="Valor"
                      />
                    </v-col>
                    <v-col>
                      <BaseButton
                        :has-icon="true"
                        color="primary"
                        class="mx-0 my-3 pa-4"
                        size="x-small"
                        @click="newBinding()"
                      >
                        <v-icon>mdi-plus-box</v-icon>
                      </BaseButton>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="binding, indexBinding in bindingList"
                    :key="indexBinding"
                    class="mb-8"
                  >
                    <v-col
                      class="px-0 py-0"
                      style="border-bottom: solid 1px #ccc;"
                    >
                      {{ binding.name }}
                    </v-col>
                    <v-col
                      class="py-0 mx-2"
                      style="border-bottom: solid 1px #ccc;"
                    >
                      {{ binding.value }}
                    </v-col>
                    <v-col class="py-0">
                      <BaseButton
                        :has-icon="true"
                        color="primary"
                        class="ma-0 pa-4"
                        size="x-small"
                        @click="deleteBinding(indexBinding)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </BaseButton>
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>
            </v-form>
          </v-tabs-items>
        </BaseCard>
        <v-dialog
          v-model="simpleModal.active"
          max-width="560"
          persistent
        >
          <BaseModal
            :show-indeterminate-progress="simpleModal.showIndeterminateProgress"
            :top-slot-content-title="simpleModal.topSlotContentTitle"
            :remove-button-close="simpleModal.removeButtonClose"
            :middle-image="simpleModal.middleImage"
            :middle-slot-content-text-highlight="simpleModal.middleSlotContentTextHighlight"
            :middle-slot-content-text="simpleModal.middleSlotContentText"
            :middle-check-agree="simpleModal.middleCheckAgree"
            :bottom-buttons-align="simpleModal.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="simpleModal.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="simpleModal.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="simpleModal.removeButtonCancel"
            :remove-button-confirm="simpleModal.removeButtonConfirm"
            :custom-enable-bottom-button-confirm-label="simpleModal.customEnableBottomButtonConfirmLabel"
            @on-cancel="simpleModal.onCancel"
            @on-confirm="simpleModal.onConfirm"
          />
        </v-dialog>
        <v-dialog
          v-model="isModalConfigActive"
          content-class="v-dialog--fullscreen"
          transition="app-transition-to-right"
          persistent
        >
          <BaseModal
            style="height: 100vh;flex-wrap:nowrap;"
            :show-indeterminate-progress="configModal.showIndeterminateProgress"
            :top-slot-content-title="configModal.topSlotContentTitle"
            :remove-button-close="configModal.removeButtonClose"
            :middle-image="configModal.middleImage"
            :middle-slot-content-text-highlight="configModal.middleSlotContentTextHighlight"
            :middle-slot-content-text="configModal.middleSlotContentText"
            :middle-check-agree="configModal.middleCheckAgree"
            :bottom-buttons-align="configModal.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="configModal.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="configModal.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="configModal.removeButtonCancel"
            :remove-button-confirm="configModal.removeButtonConfirm"
            :custom-enable-bottom-button-confirm-label="configModal.customEnableBottomButtonConfirmLabel"
            :modal-full-screen="true"
            @on-cancel="() => isModalConfigActive = false"
            @on-confirm="() => {}"
          >
            <DeveloperConfigMutant
              :config-parameter="true"
              @onInsertPath="insertPath"
            />
          </BaseModal>
        </v-dialog>
        <BaseSnackbar
          :active-snackbar="feedback"
          :type-snackbar="feedbackColor"
          :text-snackbar="feedbackMessage"
          @closeSnackbar="feedback = !feedback"
        />
      </div>
    </v-col>
    <v-col
      v-if="testProcessor"
      class="modal-processor-test"
      style="overflow-y: scroll; height: calc(100vh - 132px);"
    >
      <ModalTestProcessor
        :open-test-processor="testProcessor"
        :uuid-processor="processorObject.processorConfUuid"
        @showDiffModal="showDiffModal"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import BaseDataTable from '../../BaseDataTable'
import BaseCard from '../../BaseCard'
import BaseModal from '../../BaseModal'
import BaseCodemirror from '../../BaseCodemirror'
import BaseBreadcrumb from '../../BaseBreadcrumb'
import ProtobofSchema from './ProtobofSchema'
import ModalTestProcessor from './ModalTestProcessor'
import UtilsCodemirror from '../../../mixins/UtilsCodemirror'
import DeveloperConfigMutant from './DeveloperConfigMutant'

export default {
  components: { BaseSnackbar, BaseDataTable, BaseCard, BaseCodemirror, BaseModal, BaseBreadcrumb, ProtobofSchema, ModalTestProcessor, DeveloperConfigMutant },
  mixins: [ BaseSnackbarConfiguration, UtilsCodemirror ],
  props:{
    processorAreEdited: {
      type: Boolean,
      required: true
    },
    processorInitiator: {
      type: String,
      required: false,
      default: ()=>''
    },
    updateProcessorApi: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    formIsValid: false,
    tabIndex: null,
    testProcessor: false,
    processorObject: {},
    isIdCopied: false,
    isEditingProcessor: false,
    isEditingParam: null,
    expandParamValue: {},
    currentParam: {},
    simpleModal: {
      active: false,
      action: '',
      showIndeterminateProgress: false,
      topSlotContentTitle: "",
      removeButtonClose: true,
      middleSlotContentTextHighlight: "",
      middleSlotContentText: "",
      middleCheckAgree: null,
      bottomButtonsAlign: "right",
      bottomSlotContentButtonCancelLabel: "Cancelar",
      bottomSlotContentButtonConfirmLabel: "",
      removeButtonCancel: false,
      removeButtonConfirm: false,
      customEnableBottomButtonConfirmLabel: true
    },
    processorSearchLoad: false,
    isTestingScript: false,
    testIndexScript: null,
    schemaList: [],
    nameSchema: '',
    countStepSchema: 0,
    schemaMessageDetails: [],
    filteredSchemaDetailsList: [],
    schemaMessageList: [],
    filteredSchemaList: [],
    modelFilterSchema: '',
    resultTest: {},
    showAlert: true,
    bindingList: [],
    bindingName: '',
    bindingValue: '',
    indexCurrentRule: 0,
    rulesLogs: [],
    currentTimestamp: null,
    highlightListField: [],
    parseResult: false,
    showProtobufSchema: false,
    currentInitiatedBy: null,
    isModalConfigActive: false,
    configModal: {
      showIndeterminateProgress: false,
      topSlotContentTitle: "Inserir path no parâmetro",
      removeButtonClose: false,
      middleSlotContentTextHighlight: "",
      middleSlotContentText: "",
      middleCheckAgree: null,
      bottomButtonsAlign: "right",
      bottomSlotContentButtonCancelLabel: "",
      bottomSlotContentButtonConfirmLabel: "",
      removeButtonCancel: true,
      removeButtonConfirm: true,
      customEnableBottomButtonConfirmLabel: true
    },
    indexParameter: null
  }),
  computed: {
    ...mapState({
      eventTypesList: state => state.common.eventTypesList,
      processorDetailApi: state => state.common.processorDetail
    }),
    breadcrumbList(){
      return {
        paths: [
          {
            path: '',
            name: this.processorInitiator || 'DEFAULT'
          },
          {
            path: '',
            name: this.processorObject.processorContext
          },
          {
            path: '',
            name: this.processorObject.eventType
          },
          {
            path: '',
            name: this.processorObject.alias ? `${this.processorObject.alias} (${this.processorObject.processorName})` : this.processorObject.processorName
          }
        ]
      }
    }
  },
  watch: {
    processorObject: {
      handler(newValue, oldValue) {
        if(JSON.stringify(oldValue) !== '{}'){
          this.$emit('updateProcessorObjetc', this.processorObject)
        }
      },
      deep: true
    },
    processorDetailApi: {
      handler(){
        this.getObjectProcessor()
      },
      deep: true
    },
    processorAreEdited: {
      handler(value){
        if(!value){
          this.getRulesLogs()
          this.resetData()
        }
      },
      deep: true
    },
    updateProcessorApi(){
      this.disableForm()
    }
  },
  created(){
    this.getObjectProcessor()
    this.getRulesLogs()
  },
  methods:{
    ...mapActions(['apiGetProcessorDefinition', 'apiGetScriptValidation', 'apiGetRulesLogs']),
    testingProcessor(){
      this.testProcessor = !this.testProcessor
    },
    handleValue(value) {
      this.replaceCodemirrorValue('CodemirrorEditor', value)
    },
    async copyId(item){
      await navigator.clipboard.writeText(item)
      this.isIdCopied = true
      setTimeout(() => {
        this.isIdCopied = false
      }, 900);
    },
    getObjectProcessor(){
      this.processorObject = Object.assign({}, {...this.processorDetailApi})
      this.lastLogVersion = Object.assign({}, this.processorObject)
      this.$forceUpdate()
    },
    hideItems(item){
      let hideKeys = ['processorParams', 'comment', 'eventProcessor']
      return !hideKeys.includes(item)
    },
    parseName(name){
      const nameList = {
        processorConfUuid: "Id",
        eventType: "Event Type",
        processorContext: "Context",
        processorMatchers: "Matchers",
        processorParentName: "Parent Processor",
        executionStep: "Execution Step",
        processorPriority: "Prioridade",
        processorName: "Event Process"
      }
      return nameList[name] || name
    },
    closeSimpleModal(){
      Object.assign(this.simpleModal, {
        active: false
      })
    },
    deleteParam(param, index){
      Object.assign(this.simpleModal, {
        active: true,
        topSlotContentTitle: "Deletar parâmetro",
        middleSlotContentText: `<p>Deseja remover o parâmetro <b>${param.param}</b> da lista?</p>`,
        bottomSlotContentButtonConfirmLabel: "Deletar",
        removeButtonConfirm: false,
        onConfirm: () => {
          this.cancelEditParam(index)
          this.closeSimpleModal()
        },
        onCancel: () => this.closeSimpleModal()
      })
    },
    editParam(param, index){
      this.currentParam = JSON.stringify(param)
      this.isEditingParam = index
    },
    addParam(){
      let index = this.processorObject.processorParams.length
      this.processorObject.processorParams.push({ param: '', type: '', value: '', isNew: true});
      this.isEditingParam = index
      setTimeout(() => {
        document.getElementsByClassName("param-card")[index].scrollIntoView({ behavior: 'smooth' });
      },100);

    },
    undoParamChanges(param, index){
      Object.assign(this.simpleModal, {
        active: true,
        topSlotContentTitle: "Desfazer alterações",
        middleSlotContentText: `<p>Caso não queira perder as mudanças, clique em "CANCELAR". Na tela abaixo, clique no botão "OK" e salve o processador.</p><br /><p><b>Deseja desfazer as alterações feitas neste parâmetro <b>${param.param}</b>?</b></p>`,
        bottomSlotContentButtonConfirmLabel: "Desfazer",
        removeButtonConfirm: false,
        onConfirm: () => {
          this.$set(this.processorObject.processorParams[index], 'param', JSON.parse(this.currentParam).param)
          this.$set(this.processorObject.processorParams[index], 'type', JSON.parse(this.currentParam).type)
          this.$set(this.processorObject.processorParams[index], 'value', JSON.parse(this.currentParam).value)

          this.$emit('updateProcessorObjetc', this.processorObject)
          this.isEditingParam = null
          this.currentParam = {}
          this.closeSimpleModal()
          this.$forceUpdate()
        },
        onCancel: () => this.closeSimpleModal()
      })
    },
    showUndoButton(index){
      let isValueDiferent = JSON.stringify(this.currentParam) !== '{}' && (JSON.stringify(this.processorObject.processorParams[index]) !== this.currentParam ? true : false)

      return this.isEditingParam === index && isValueDiferent
    },
    expandParam(index){
      this.$set(this.expandParamValue, index, this.expandParamValue[index] ? false : true)
    },
    validateJson(value){
      let msg = ''
      try {
        JSON.parse(value);
        msg = "<b>Successo</b>: O JSON é válido!"
      } catch(e) {
        msg = "<b>Erro</b>: O JSON não é válido! - " + e
      }

      Object.assign(this.simpleModal, {
        active: true,
        topSlotContentTitle: "Validar JSON",
        middleSlotContentText: `<p>${msg}</p>`,
        bottomSlotContentButtonCancelLabel: "Fechar",
        removeButtonConfirm: true,
        onConfirm: ()=>{},
        onCancel: () => this.closeSimpleModal()
      })
    },
    async searchProcessorDefinition(processor){
      this.processorSearchLoad = true;

      let result = await this.apiGetProcessorDefinition(processor)

      if (!result.params) {
        this.processorObject.processorParams = [];
      } else {
        result.params.forEach(param => {
          let isAddParameter = true;

          if (this.processorObject.processorParams && this.processorObject.processorParams.length === 0) {
            this.processorObject.processorParams.push({
              param: param.name,
              type: this.parseParamType(param.type),
              value: param.description
            })
          } else {
            this.processorObject.processorParams.forEach((elementGroup, indexGroup) => {
              if(param.name === elementGroup.param){
                isAddParameter = false;
              }
              if(this.processorObject.processorParams && this.processorObject.processorParams.length - 1 === indexGroup && isAddParameter){
                this.processorObject.processorParams.push({
                  param: param.name,
                  type: this.parseParamType(param.type),
                  value: param.description
                });
              }
            });
          }
        });
        this.$forceUpdate()
      }
      this.processorSearchLoad = false;
    },
    parseParamType(type) {
      let t =  type.split('.')
      let clazz = t[t.length-1];

      if (clazz === "MAP")
        return "JSON"

      return "STRING";
    },
    testScript(index){
      this.isTestingScript = true
      this.testIndexScript = index
      this.testProcessor = false

      if(!this.bindingList.find( p => p.value === this.processorInitiator))
      this.bindingList.push({
        "name" : "initiator",
        "value": this.processorInitiator
      })

      setTimeout(() => {
        document.getElementsByClassName("modal-processor-detail")[0].scrollIntoView({ behavior: 'smooth' });
      }, 400);
    },
    disableForm(index = null){
      this.isEditingParam = null;
      this.currentParam = {};
      if(index != null){
        delete this.processorObject.processorParams[index].isNew
      }
    },
    closeScriptTest() {
      this.isTestingScript = false;
      this.resultTest = {}
      this.bindingList = []

      setTimeout(() => {
        document.getElementsByClassName("param-card")[this.testIndexScript].scrollIntoView({ behavior: 'smooth' });
      },100);
    },
    newBinding() {
      this.bindingList.push({
        name: this.bindingName,
        value: this.bindingValue
      })
      this.bindingName = "";
      this.bindingValue = "";
    },
    deleteBinding(index) {
      this.bindingList.splice(index, 1)
    },
    async scriptValidation(){
      try {
        this.showAlert = false
        let payload = {
          script: this.processorObject.processorParams[this.testIndexScript].value,
          params: this.bindingList
        }
        this.resultTest = await this.apiGetScriptValidation(payload)
        this.showAlert = true

        setTimeout(() => {
          document.getElementsByClassName("app-result-block")[0].scrollIntoView({ behavior: 'smooth' });
        },100);
      } catch (error) {
        this.showFeedback({
          message: 'Erro ao testar o script',
          color: 'error'
        })
      }
    },

    formatInitiatedBy(value) {
      if (!value) return '-'
      return value.startsWith('api') ? value.replace('api:', '') : value
    },
    selectLog(index){
      let options = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false,
      };

      let dateFormat = new Intl.DateTimeFormat('pt-BR', options);

      this.currentInitiatedBy = this.rulesLogs[index].initiated_by ?
        this.rulesLogs[index].initiated_by.startsWith('api') ?
          this.rulesLogs[index].initiated_by.replace('api:', '') :
          this.rulesLogs[index].initiated_by : '-'

      this.indexCurrentRule = index;
      this.highlightListField = [];
      this.currentTimestamp = dateFormat.format(new Date(this.rulesLogs[index].timestamp))
      let currentLog = this.rulesLogs[index] ? JSON.parse(this.rulesLogs[index].data.payload) : {}
      this.$emit('onChangeLog', {
        index: this.indexCurrentRule,
        date: this.currentTimestamp
      })
      this.compareLogs(this.lastLogVersion, currentLog)
    },
    compareLogs(lastLog, currentLog, paramIndex = -1) {
      if(this.indexCurrentRule === 0){
        this.getObjectProcessor()
        this.resetData()
      } else {
        Object.keys(lastLog).forEach(prop => {
          if(!(!lastLog[prop] && !currentLog[prop])) {
            if(prop == 'processorParams') {
              this.$set(this.processorObject, 'processorParams', currentLog[prop])
              this.highlightProcessorParams(lastLog[prop], currentLog[prop])
            } else {
              paramIndex > -1 ? null : this.$set(this.processorObject, prop, currentLog[prop])
              if(lastLog[prop] !== currentLog[prop]) {
                paramIndex > -1 ? this.addHighlightField(prop+paramIndex) : this.addHighlightField(prop)
              }
            }
          }
        })
      }
    },
    highlightProcessorParams(lastLogProp, currentLogProp){
      let currentLogLength = currentLogProp ? currentLogProp.length-1 : null

      lastLogProp.forEach((p, index) => {
        if(lastLogProp.length-1 == index && currentLogLength && currentLogLength != index){
          for(let i = index+1; i == currentLogLength; i++){
            this.addHighlightField(`param-${i}`)
          }
        }
        (lastLogProp && !currentLogProp) || !currentLogProp[index] ?
        this.addHighlightField(`param-${index}`)
          : this.compareLogs(p, currentLogProp[index], index)
      })
    },
    addHighlightField(value){
      this.highlightListField.push(value)
    },
    highlightField(field){
      return this.highlightListField.findIndex(elem => elem == field) > -1 ? true : false
    },
    resetData() {
      this.indexCurrentRule = 0
      this.highlightListField = [];
      this.currentTimestamp = null;
      this.$emit('onChangeLog', {
        index: null,
        date: null
      })
    },
    async getRulesLogs(){
      let result = await this.apiGetRulesLogs({processorId: this.processorObject.processorConfUuid})
      this.rulesLogs = result.content
    },
    resultStatus(result){
      let resultStatus = {
        "ERROR": {
          color: "red",
          text: "Erro",
          action: () => this.copyId(result.message)
        },
        "OK": {
          color: "green",
          text: "Sucesso",
          action: () => this.copyId(result.value)
        }
      }
      return resultStatus[result.status]
    },
    cancelEditParam(index){
      this.processorObject.processorParams.splice(index, 1);
      this.isEditingParam = null
    },
    showDiffModal(value){
      this.$emit("showDiffModal", value)
    },
    modalConfigMutant(index) {
      this.isModalConfigActive = true
      this.indexParameter = index
    },
    insertPath(path) {
      this.isModalConfigActive = false
      const refCodemirror = `key-param-value-${this.indexParameter}`
      this.setCodemirrorValue(refCodemirror, `config://${path}`)
    }
  },
}
</script>
<style lang="scss">
.modal-processor-detail {
  .custom-highlight-field, .custom-highlight-div-field {
    background: rgba(251,140,0,.22)!important;
    .v-icon.v-icon {
      font-size: 16px;
    }
  }
}
.param-value-processor {
  .v-label--is-disabled, textarea {
    color: var(--custom-theme-black-054)!important;
  }
  .v-label--is-disabled {
    font-weight: bold;
    font-size: 1.175rem;
  }
}

</style>
